import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_DATA from "./KAMPYLE_DATA";
import KAMPYLE_EVENT_DISPATCHER from "./KAMPYLE_EVENT_DISPATCHER";
import KAMPYLE_FUNC from "./KAMPYLE_FUNC";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import KAMPYLE_COMMON from "./KAMPYLE_COMMON";
import MDIGITAL_CONFIGURATION from './MDIGITAL_CONFIGURATION';
import MDIGITAL_ELEMENT_BUILDER from './MDIGITAL_ELEMENT_BUILDER';
import KAMPYLE_SCREEN_CAPTURE from "./KAMPYLE_SCREEN_CAPTURE";

  var ON_LOAD_ONPREM_CALLBACK_NAME = 'onUsersnapLoad';
  var SCROLLABLE_OVERFLOW = 'scroll';

  var formData, userSnapInstance = false;

  //http://jsfiddle.net/367Aq/1/
  var screenCaptureTooltipStyles =
  '[data-tips]{position:relative;text-decoration:none}[data-tips]:after,[data-tips]:before{position:absolute;z-index:100;opacity:0}[data-tips]:after{content:attr(data-tips);line-height:20px;padding:0 10px;font-size:12px;text-align:center;color:#fff;background:#222;border-radius:5px;text-shadow:0 0 5px #000;-moz-box-shadow:0 0 5px rgba(0, 0, 0, .3);-webkit-box-shadow:0 0 5px rgba(0, 0, 0, .3);box-shadow:0 0 5px rgba(0, 0, 0, .3);white-space:normal;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;width:135px;word-wrap:break-word}[data-tips]:before{content:"";width:0;height:0;border-width:6px;border-style:solid}[data-tips]:hover:after,[data-tips]:hover:before{opacity:1}[data-tips].top-tip:after,[data-tips].top-tip:before{-webkit-transition:bottom .25s ease-in-out, opacity .25s ease-in-out;-moz-transition:bottom .25s ease-in-out, opacity .25s ease-in-out;transition:bottom .25s ease-in-out, opacity .25s ease-in-out;bottom:90%;left:-9999px;margin-bottom:12px}[data-tips].top-tip:before{border-color:#222 transparent transparent;margin-bottom:0}[data-tips].top-tip:hover:after,[data-tips].top-tip:hover:before{bottom:100%;left:0}[data-tips].top-tip:hover:before{left:15px}[data-tips].bottom-tip:after,[data-tips].bottom-tip:before{-webkit-transition:top .25s ease-in-out, opacity .25s ease-in-out;-moz-transition:top .25s ease-in-out, opacity .25s ease-in-out;transition:top .25s ease-in-out, opacity .25s ease-in-out;top:90%;left:-9999px;margin-top:12px}[data-tips].bottom-tip:before{border-color:transparent transparent #222;margin-top:0}[data-tips].bottom-tip:hover:after,[data-tips].bottom-tip:hover:before{top:100%;left:0}[data-tips].bottom-tip:hover:before{left:15px}[data-tips].left-tip:after,[data-tips].left-tip:before{-webkit-transition:left .25s ease-in-out, opacity .25s ease-in-out;-moz-transition:left .25s ease-in-out, opacity .25s ease-in-out;transition:left .25s ease-in-out, opacity .25s ease-in-out;top:-9999px;left:96%;margin-left:12px}[data-tips].left-tip:before{border-color:transparent #222 transparent transparent;margin-left:0}[data-tips].left-tip:hover:after,[data-tips].left-tip:hover:before{left:100%;top:0}[data-tips].left-tip:hover:before{top:7px}[data-tips].right-tip:after,[data-tips].right-tip:before{-webkit-transition:right .25s ease-in-out, opacity .25s ease-in-out;-moz-transition:right .25s ease-in-out, opacity .25s ease-in-out;transition:right .25s ease-in-out, opacity .25s ease-in-out;top:-9999px;right:96%;margin-right:12px}[data-tips].right-tip:before{border-color:transparent transparent transparent #222;margin-right:0}[data-tips].right-tip:hover:after,[data-tips].right-tip:hover:before{right:100%;top:0}[data-tips].right-tip:hover:before{top:7px}';
var screenCaptureButtonsOutlineStyle =
  ".scTitle:focus, .scParagraph:focus, .sc-widget-footer-cancel:focus, .sc-widget-footer-capture:focus, p:focus { border: 2px solid #8e8e93 !important; box-shadow: 0 0 7px #8e8e93 !important;}";
var SCREEN_CAPTURE_DEFAULT_TEXTS = {
  submitScreenCaptureLabel: "Capture Image",
  cancelScreenCaptureLabel: "Cancel",
  instructionsScreenCapture:
    '<h2 class="scTitle" style="font-size: 1.5em;">Screen Capture</h2><p class="scParagraph" style="font-size: 1em; margin-top: 10px;">Drag the cursor around the area you want to highlight.<br>Press Capture Image to take the snapshot and return to your feedback</p>',
  submitScreenCaptureTooltip: "Take snapshot",
  cancelScreenCaptureTooltip: "Back to Feedback",
};

var screenCaptureWidgetTemplate = function() {
  var spinnerTemplate = KAMPYLE_COMMON.getSpinnerTemplate();

  return [
  "<html>",
  "<head>",
  '<link rel="stylesheet" type="text/css" href="' +
    KAMPYLE_CONSTANT.PLACEHOLDERS.URL_PREFIX +
    KAMPYLE_CONSTANT.SRC.OPEN_SANS +
    '" />',
  '<script type="text/javascript">',
  "function resizeIframe() {",
  'parent.document.getElementById("nebScIframe").height = document.getElementById("sc-widget").scrollHeight + 15;',
  'var SCWidget = parent.document.getElementById("nebScIframe");',
  "if (SCWidget) {",
  "SCWidget.focus();",
  "}",
  "}",
  "</script>",
  "<style>{tooltipStyles} {buttonsOutlineStyle}</style>",
  "</head>",
  '<body onload="resizeIframe();" style="margin:0px;overflow:hidden;">',
  '<div id="sc-widget" class="sc-widget" style="{widget}">',
  '<div class="sc-widget-content" style="{widgetContent}">',
  "{{instructionsScreenCapture}}",
  "</div>",
  '<div class="sc-widget-footer" style="{widgetFooter}">',
  '<button onclick="parent.KAMPYLE_SCREEN_CAPTURE.onCancelScreenCaptureClick();" class="sc-widget-footer-cancel top-tip" ' +
    'data-tips="{{cancelScreenCaptureTooltip}}" style="{widgetFooterBtn} {widgetFooterCancel}">',
  "{{cancelScreenCaptureLabel}}",
  "</button>",
  '<button onclick="parent.KAMPYLE_SCREEN_CAPTURE.onSubmitScreenCaptureClick();" class="sc-widget-footer-capture top-tip" ' +
    'data-tips="{{submitScreenCaptureTooltip}}" style="{widgetFooterBtn} {widgetFooterCapture}">',
  spinnerTemplate,
  '<span id="widgetFooterCaptureText">{{submitScreenCaptureLabel}}</span>',
  "</button>",
  "</div>",
  "</div>",
  "</body></html>",
].join(" ");
}

//TODO - refactor to objects
var defaultStyles = {
  overlay: {
    position: "fixed",
    top: "0",
    left: "0",
    "z-index": "2147483646 !important",
    right: "0",
    bottom: "0",
    display: "block",
    "pointer-events": "none",
  },
  widget: {
    "font-family": "'Open Sans'",
    border: "1px solid #999",
    width: "285px",
    "border-radius": "5px",
    position: "absolute",
    "z-index": "2147483647 !important",
    "pointer-events": "auto",
    background: "#FFFFFF",
    "text-align": "center",
    "line-height": "20px",
  },
  widgetContent: {
    padding: "10px 14px",
    outline: "none",
  },
  widgetFooter: {
    "font-family": "'Open Sans' !important",
    padding: "10px",
    "font-size": "14px",
    "padding-top": "0",
    "font-stretch": "normal",
    "font-style": "normal",
    "font-variant": "normal",
    "font-weight": "normal",
    "letter-spacing": "normal",
    "line-height": "20px",
  },
  widgetFooterBtn: {
    height: "34px",
    margin: "0 0 2px 5px",
    "min-width": "100px",
    padding: "6px 12px",
    display: "inline-block",
    "border-radius": "4px",
    cursor: "pointer",
    "transition-delay": "0s",
    "transition-duration": "0.3s",
    "transition-property": "all",
    "transition-timing-function": "ease",
    "vertical-align": "middle",
    "white-space": "nowrap",
    "word-spacing": "0px",
    border: "none",
    color: "#FFF",
  },
  widgetFooterCancel: {
    background: "#A2A2A2",
    color: "#FFF",
  },
  widgetFooterCapture: {
    "margin-left": "5px",
    background: "#020202",
    color: "#FFF",
  },
};

  var UserSnapModel = function(){
    this.init = function(){
      this.determineWidgetVersion()
    }
    this.determineWidgetVersion = function(){
      this._usersnapOnpremWidgetLoaderPath = KAMPYLE_UTILS.getNestedPropertyValue(MDIGITAL_CONFIGURATION.getOnsiteConfiguration(),'usersnapOnpremWidgetLoaderPath');
    }
    this.close = function(){
      window.UserSnap.api.close();
    }
    this.getUrl = function(){
      return KAMPYLE_CONSTANT.PLACEHOLDERS.USERSNAP_ONPREM_HOST_PREFIX + this._usersnapOnpremWidgetLoaderPath;
    }
    this.initConfiguration = function(){
      window.usersnapConfig = {
        cdnUrl: KAMPYLE_CONSTANT.PLACEHOLDERS.USERSNAP_ONPREM_HOST_PREFIX + this._usersnapOnpremWidgetLoaderPath.slice(0, this._usersnapOnpremWidgetLoaderPath.lastIndexOf('/')),
        onLoadCallbackName: ON_LOAD_ONPREM_CALLBACK_NAME
      };
      window[ON_LOAD_ONPREM_CALLBACK_NAME] = getConfiguration();
    }
    this.getContainer = function(){
      return document.getElementsByName('us-entrypoint-widgetApp')[0];
    }
    this.initWidget = function(){
      window.UserSnap.api.open();
    }
  }

  var hideSpinner = function() {
    var iframe = document.getElementById('nebScIframe');
    if(iframe && iframe.contentDocument) {
      var spinner =  iframe.contentDocument.getElementById(KAMPYLE_CONSTANT.SPINNER_SETTINGS.CONTAINER_ID);
      if (!!spinner) {
        spinner.style.display = 'none';
  
        var text =  iframe.contentDocument.getElementById('widgetFooterCaptureText');
        if (!!text)
        {
          text.style.display = 'inline';
        }
      }
    }
  };

  var cancelCaptureClicked = function() {
    formData.canceledClicked = true;
    userSnapInstance.close();
  }

  function closeScreenCaptureWidget(){
    var container = document.getElementById('us_sandbox');
    if (!!container)
    {
      container.style.display = 'none';
    }
    var scIframe = document.getElementById('nebScIframe');
    if (!!scIframe)
    {
      scIframe.parentNode.removeChild(scIframe);
    }
  }

  function afterSend(){
    if(formData && !formData.canceledClicked){
      hideSpinner();
      closeScreenCaptureWidget();
      var eventExtraData = { formId: formData.formId, feedbackCorrelationUUID: formData.feedbackCorrelationUUID }
      KAMPYLE_EVENT_DISPATCHER.trigger('neb_captureImageClicked', eventExtraData);
      KAMPYLE_UTILS.sendMessageToIframe(KAMPYLE_DATA.getFormIframeId(formData.formId), { action: 'takenScreenCapture', data: eventExtraData});
    }
    userSnapInstance.close();
  }

  function getConfiguration(){
    return function(api) {
      api.on('open', function (event) {
        var additionalInfo = { uuid: formData.feedbackCorrelationUUID, websiteId: formData.websiteId };
        if(shouldProcessScreenCaptureAsComponent(formData)){
          additionalInfo.screenCaptureUuid = formData.screenCaptureUuid;
        }
        Object.assign(additionalInfo, {screenWidth: window.innerWidth, screenHeight: window.innerHeight})
        event.api.setValue('custom', additionalInfo);
      });
      api.on('opened', function () {
        beforeOpen()
      });
      api.on('submit', function () {
        afterSend()
      });
      api.on("close", function() {
        var scrollType = KAMPYLE_DATA.getMemoryData('overFlowType');
        handleScrollIfNeeded(formData,scrollType);
        if (formData.canceledClicked) { // to distinguish close after submit or cancel (event.isCancel flag as described in usersnap doc is not available)
          handleCaptureCancellation();
        }
      })

      api.on("domSelector:selected", function () {
        showScreenCaptureSpinner();
        api.submit();
      });

      var initParams = {
        serviceUrl: KAMPYLE_CONSTANT.PLACEHOLDERS.USERSNAP_ONPREM_HOST_PREFIX,
        mode: "headless",
        button: null,
        tools: {
          keys: ["highlight"],
          colors: [KAMPYLE_CONSTANT.COLORS.USERSNAP_V4_SELECTION_COLOR],
        },
        thankYou: {
          isHidden: true,
        },
        iframeTitle: KAMPYLE_CONSTANT.IFRAME_SETTINGS.USERSNAP_V4_IFRAME_TITLE
      };

      initParams.tools.keys[0] = getSelectedTool();
      initParams.tools.colors[0] = KAMPYLE_CONSTANT.COLORS.USERSNAP_ONPREM_SELECTION_COLOR;
      initParams.apiKey = KAMPYLE_UTILS.getNestedPropertyValue(MDIGITAL_CONFIGURATION.getOnsiteConfiguration(),'usersnapEnvId');
      
      api.init(initParams);
      window.UserSnap = {
        api: api
      };
    };
  }

  function init(callback) {
    formData = {};

    userSnapInstance = new UserSnapModel();
    userSnapInstance.init();
    userSnapInstance.initConfiguration();

    appendScreenCaptureScript();

    KAMPYLE_UTILS.objectPropertyObserver(window, 'UserSnap', callback);

    KAMPYLE_EVENT_DISPATCHER.subscribeMany({
      neb_captureInit: [initScreenCaptureWidget],
      neb_cancelCaptureClicked: [cancelCaptureClicked]
    });
  }

  function addEscKeyDownListenerToIframe(iframe) {
    if(iframe && iframe.contentDocument) {
      iframe.contentDocument.body.addEventListener('keydown', function(e) {
        if(e.key === 'Escape') {
          cancelCaptureClicked();
        }
      });
    }
  }

  function beforeOpen() {
    var container = userSnapInstance.getContainer();
    // Fix for NM-3841
    KAMPYLE_UTILS.setElementStyle(container, {
      display: 'block',
      zIndex: '2147483646',
    }, true /* !important */);

    var iframeArr = container && container.getElementsByTagName && container.getElementsByTagName('iframe');
    var scIframe = iframeArr && iframeArr[0];
    if (scIframe){
      KAMPYLE_UTILS.setElementStyle(scIframe, {
        display: 'block',
      }, true /* !important */);
      addEscKeyDownListenerToIframe(scIframe);
    } else {
      addEscKeyDownListenerToIframe(container)
    }
    var overFlowType = KAMPYLE_UTILS.getNestedPropertyValue(document,'body.style.overflow');
    KAMPYLE_DATA.setMemoryData('overFlowType',overFlowType);
    handleScrollIfNeeded(formData,SCROLLABLE_OVERFLOW);

    createScreenCaptureWidget(formData, container);
  }

  function setBodyOverflowType(scrollType){
    var bodyElement = document.body;
    if(!bodyElement) return;
    KAMPYLE_UTILS.setElementStyle(bodyElement,{
      overflow:scrollType
    })
  }

  function handleScrollIfNeeded(formData,scrollType){
    var fullFormData = KAMPYLE_DATA.getFormData(formData.formId);
    var displayType = KAMPYLE_DATA.getDisplayType(fullFormData);
    var selectedTool = KAMPYLE_SCREEN_CAPTURE.getSelectedTool();
    if(displayType === KAMPYLE_CONSTANT.DISPLAY_TYPES.LIGHTBOX && selectedTool === KAMPYLE_CONSTANT.SCREEN_CAPTURE.DOM_SELECTION_VALUE){
      KAMPYLE_SCREEN_CAPTURE.setBodyOverflowType(scrollType);
    }
  }

  function initScreenCaptureWidget(eventName, data){
    data = data || {};
    formData.feedbackCorrelationUUID = data.feedbackCorrelationUUID;
    if(shouldProcessScreenCaptureAsComponent(data)){
      formData.screenCaptureUuid = data.screenCaptureUuid;
    }

    // We have async events outsite the event dispatcher context where we don't have the uuid
    KAMPYLE_DATA.setMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.FEEDBACK_CORRELATION_UUID, formData.feedbackCorrelationUUID);

    formData.websiteId = data.websiteId;
    formData.accountId = data.accountId;
    formData.formId = data.formId;
    formData.screenCaptureSettings = data.screenCaptureSettings;
    formData.canceledClicked = false;
    userSnapInstance.initWidget();
  }

  function handleCaptureCancellation() {
    KAMPYLE_SCREEN_CAPTURE.closeScreenCaptureWidget();
    var formId = KAMPYLE_DATA.getMemoryData('currentFormId');
    KAMPYLE_EVENT_DISPATCHER.trigger('MDigital_Capture_Cancelled', {
      formId: formId,
      feedbackCorrelationUUID: KAMPYLE_DATA.getMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.FEEDBACK_CORRELATION_UUID),
    });
    var formData = KAMPYLE_DATA.getFormData(formId);
    KAMPYLE_UTILS.sendMessageToIframe(KAMPYLE_DATA.getFormIframeId(formId), { action: 'cancelScreenCapture', data: formData });
  }

  function appendScreenCaptureScript () {
    var id = 'kampyleSceenCaptureScript';
    if(document.getElementById(id)) { return false; }

    var scriptElem = document.createElement('script');
    Object.assign(scriptElem, {
      id:id,
      type: 'text/javascript',
      src: userSnapInstance.getUrl()
    });

    document.body.appendChild(scriptElem);
  }

  function shouldProcessScreenCaptureAsComponent(data){
    var isScreenCaptureEnabled =  KAMPYLE_UTILS.getNestedPropertyValue(data, 'screenCaptureSettings.screenCaptureAsComponentEnabled');
    return KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.USER_SNAP_AS_COMPONENT) && isScreenCaptureEnabled;
  }

    function getSelectedTool() {
      var config = MDIGITAL_CONFIGURATION.getOnsiteConfiguration();
      return config.screenCaptureSelectionTool ===
        KAMPYLE_CONSTANT.SCREEN_CAPTURE.DOM_SELECTION
        ? KAMPYLE_CONSTANT.SCREEN_CAPTURE.DOM_SELECTION_VALUE
        : KAMPYLE_CONSTANT.SCREEN_CAPTURE.AREA_SELECTION_VALUE;
    }
    
  function getUserSnapInstance() {
    return userSnapInstance
  }

  function overrideDefaultScreenCaptureStyles(customSettings) {
    var res = defaultStyles;

    //override styles if defined
    if (!!customSettings) {
      res.widget.background = !!customSettings.backgroundColor
        ? customSettings.backgroundColor
        : res.widget.background;
      res.widgetFooterCapture.background = !!customSettings.submitButtoncolor
        ? customSettings.submitButtoncolor
        : res.widgetFooterCapture.background;
      res.widgetFooterCancel.background = !!customSettings.closeButtoncolor
        ? customSettings.closeButtoncolor
        : res.widgetFooterCancel.background;
      res.widgetFooterCancel.color = !!customSettings.closeButtonTextColor
        ? customSettings.closeButtonTextColor
        : res.widgetFooterBtn.color;
      res.widgetFooterCapture.color = !!customSettings.submitButtonTextColor
        ? customSettings.submitButtonTextColor
        : res.widgetFooterBtn.color;
    }
    return res;
  }

  function overrideDefaultScreenCaptureTexts(customSettings) {
    var res = SCREEN_CAPTURE_DEFAULT_TEXTS;

    if (!!customSettings) {
      for (var prop in res) {
        if (customSettings.hasOwnProperty(prop) && res.hasOwnProperty(prop)) {
          res[prop] = customSettings[prop];
        }
      }
      return res;
    }
  }

  function showScreenCaptureSpinner() {
    //Show spinner
    var iframeDocument = document.getElementById("nebScIframe").contentDocument;
    var spinnerContainer = iframeDocument.getElementById(
      KAMPYLE_CONSTANT.SPINNER_SETTINGS.CONTAINER_ID
    );
    if (!!spinnerContainer) {
      KAMPYLE_UTILS.setSpinnerStyle(
        spinnerContainer,
        KAMPYLE_CONSTANT.SPINNER_SETTINGS.SIZE.SMALL,
        iframeDocument
      );
      var text = iframeDocument.getElementById("widgetFooterCaptureText");
      if (!!text) {
        text.style.display = "none";
      }
    }
  }

  function isScreenCaptureEnabled(formId) {
    var formJson = KAMPYLE_DATA.getFormData(formId);

    if (!formJson) {
      return false;
    }

    var displayType = KAMPYLE_DATA.getDisplayType(formJson);

    return (
      !!displayType &&
      displayType !== "popup"
    );
  }

  function formatScreenCaptureWidget(formData) {
    formData = formData || {};
    var widgetHtml = screenCaptureWidgetTemplate();
    //Add default texts to template
    var formattedText = overrideDefaultScreenCaptureTexts(
      formData.screenCaptureSettings
    );

    // BUG - remove tooltip placeholders in case there isn't a tooltip
    if (!formattedText || !formattedText.submitScreenCaptureTooltip) {
      widgetHtml = widgetHtml.replace(
        'data-tips="{{submitScreenCaptureTooltip}}"',
        ""
      );
    }
    if (!formattedText || !formattedText.cancelScreenCaptureTooltip) {
      widgetHtml = widgetHtml.replace(
        'data-tips="{{cancelScreenCaptureTooltip}}"',
        ""
      );
    }

    for (var prop in formattedText) {
      if (SCREEN_CAPTURE_DEFAULT_TEXTS.hasOwnProperty(prop)) {
        widgetHtml = widgetHtml.replace(
          "{{" + prop + "}}",
          SCREEN_CAPTURE_DEFAULT_TEXTS[prop]
        );
      }
    }

    var formattedStyles = overrideDefaultScreenCaptureStyles(
      formData.screenCaptureSettings
    );

    //Add the default styles to the html template
    for (var element in formattedStyles) {
      widgetHtml = KAMPYLE_UTILS.replaceAll(
        widgetHtml,
        "{" + element + "}",
        KAMPYLE_UTILS.styleObjToInline(defaultStyles[element])
      );
    }

    widgetHtml = widgetHtml
      .replace("{tooltipStyles}", screenCaptureTooltipStyles)
      .replace("{buttonsOutlineStyle}", screenCaptureButtonsOutlineStyle);

    return KAMPYLE_UTILS.htmlDecode(widgetHtml);
  }

  function createScreenCaptureWidget(formData, scContainer) {
    if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.CSP_RULES)){
      KAMPYLE_SCREEN_CAPTURE.createScreenCaptureInstructionWidget(
        formData,
        scContainer
      );
    } else {
      var widgetHtml = formatScreenCaptureWidget(formData);

      //Create the SC widget iframe
      var scIframe = document.createElement("iframe");
      scIframe.addEventListener('load', function() {
        addEscKeyDownListenerToIframe(scIframe)
      });
      scIframe.id = "nebScIframe";
      KAMPYLE_UTILS.setElementStyle(scIframe, {
        width: "310px",
        bottom: "20px",
        left: "20px",
        zIndex: 2147483647,
        position: "fixed",
      });
      KAMPYLE_UTILS.setElementStyle(
        scIframe,
        {
          display: "block",
        },
        true
      );
      scIframe.frameBorder = "0";
      scIframe.sandbox = "allow-top-navigation allow-same-origin allow-scripts";

      if (scContainer) {
        // Usersnap
        scContainer.parentNode.insertBefore(scIframe, scContainer);
      } else {
        // Native Screen Capture
        document.body.appendChild(scIframe);
      }

      if (scIframe.contentWindow) {
        scIframe.contentWindow.contents = widgetHtml;
      }
      scIframe.src = 'javascript:window["contents"]';

      //Remove focus from the form iframe so document.onkeyup will fire
      setTimeout(function () {
        document.activeElement.blur();
      }, 100);
      return true;
    }
  }

  function onCancelScreenCaptureClick() {
    KAMPYLE_EVENT_DISPATCHER.trigger("neb_cancelCaptureClicked", {
      formId: KAMPYLE_DATA.getMemoryData("currentFormId"),
      feedbackCorrelationUUID: KAMPYLE_DATA.getMemoryData(
        KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.FEEDBACK_CORRELATION_UUID
      ),
    });
  }

  function onSubmitScreenCaptureClick() {
    showScreenCaptureSpinner();
    window.UserSnap.api.submit();
  }

  function createScreenCaptureHeader() {
    var headElem = document.createElement('head');
    var linkElem = document.createElement('link');
    linkElem.rel = 'stylesheet';
    linkElem.type = 'text/css';
    linkElem.href = KAMPYLE_CONSTANT.PLACEHOLDERS.URL_PREFIX + KAMPYLE_CONSTANT.SRC.OPEN_SANS;
    headElem.appendChild(linkElem);
    return headElem;
  }

  function getScreenCaptureDescription(formData){
    if(formData.screenCaptureSettings){
      return formData.screenCaptureSettings.bodyInstructionsScreenCapture || formData.screenCaptureSettings.instructionsScreenCapture || KAMPYLE_CONSTANT.TEXTS.SCREEN_CAPTURE.DEFAULT_DESCRIPTION;
    }
    return KAMPYLE_CONSTANT.TEXTS.SCREEN_CAPTURE.DEFAULT_DESCRIPTION;
  }

  function createScreenCaptureFooter(formattedText, formattedStyles) {
    var divFooter = document.createElement('div');
    divFooter.className = 'sc-widget-footer';
    KAMPYLE_UTILS.setElementStyle(divFooter, {
      'font-family': '\'Open Sans\'',
      'padding': '10px',
      'font-size': '14px',
      'padding-top': '0',
      'font-stretch': 'normal',
      'font-style': 'normal',
      'font-variant': 'normal',
      'font-weight': 'normal',
      'letter-spacing': 'normal',
      'line-height': '20px'
    });
    var cancelBtn = document.createElement('button');
    cancelBtn.className = 'sc-widget-footer-cancel top-tip';
    KAMPYLE_UTILS.addAttributesOnElement(cancelBtn, {
      class: 'sc-widget-footer-cancel top-tip',
      title: formattedText.cancelScreenCaptureTooltip
    });
    cancelBtn.addEventListener('click', function(){ onCancelScreenCaptureClick()});
    KAMPYLE_UTILS.setElementStyle(cancelBtn, Object.assign({outline: 'none'}, formattedStyles.widgetFooterCancel, formattedStyles.widgetFooterBtn));
    var cancelBtnText = document.createTextNode(formattedText.cancelScreenCaptureLabel);
    cancelBtn.appendChild(cancelBtnText);

    var submitBtn = document.createElement('button');
    KAMPYLE_UTILS.addAttributesOnElement(submitBtn, {
      class: 'sc-widget-footer-capture top-tip',
      title: formattedText.submitScreenCaptureTooltip
    });
    submitBtn.addEventListener('click', onSubmitScreenCaptureClick);
    KAMPYLE_UTILS.setElementStyle(submitBtn, Object.assign({outline: 'none'}, formattedStyles.widgetFooterCapture, formattedStyles.widgetFooterBtn));
    var spinnerContainer = MDIGITAL_ELEMENT_BUILDER.createSpinnerElement();
    var spanElem = document.createElement('span');
    spanElem.id = 'widgetFooterCaptureText';
    spanElem.appendChild(document.createTextNode(formattedText.submitScreenCaptureLabel));
    submitBtn.appendChild(spinnerContainer);
    submitBtn.appendChild(spanElem);
    divFooter.appendChild(cancelBtn);
    divFooter.appendChild(submitBtn);
    return divFooter;
  }

  function createScreenCaptureIframe(htmlElem, scContainer) {
    var scIframe = document.createElement('iframe');
    scIframe.id = 'nebScIframe';
    KAMPYLE_UTILS.setElementStyle(scIframe, {
      width: '310px',
      bottom: '20px',
      left: '20px',
      zIndex: 2147483647,
      position: 'fixed',
    });
    KAMPYLE_UTILS.setElementStyle(scIframe, {
      display: 'block'
    }, true);
    scIframe.frameBorder = '0';
    scIframe.sandbox = 'allow-top-navigation allow-same-origin allow-scripts';
    if (scContainer) { // Usersnap
      scContainer.parentNode.insertBefore(scIframe, scContainer);
    } else { // Native Screen Capture
      document.body.appendChild(scIframe);
    }
    var docIframe = scIframe.contentDocument || scIframe.contentWindow.document;
    docIframe.open();
    docIframe.write("<html><head></head><body></body></html>");
    docIframe.close();
    docIframe.replaceChild(htmlElem, docIframe.getElementsByTagName("html")[0])
    scIframe.height = docIframe.getElementById("sc-widget") && docIframe.getElementById("sc-widget").scrollHeight + 20;
    setTimeout(function () {
      document.activeElement.blur();
    }, 100);
    return true;
  }

  function createScreenCaptureBody(formData, divFooter, formattedStyles) {
    var bodyElem = document.createElement('body');
    KAMPYLE_UTILS.setElementStyle(bodyElem, {margin: '0px', overflow: 'hidden'});
    var divWrapper = document.createElement('div');
    divWrapper.id = 'sc-widget';
    divWrapper.className = 'sc-widget';
    KAMPYLE_UTILS.setElementStyle(divWrapper, formattedStyles.widget);
    KAMPYLE_UTILS.setElementStyle(divWrapper, {zIndex: '2147483646'});
    var widgetContentElem = document.createElement('div');
    widgetContentElem.className = 'sc-widget-content';
    KAMPYLE_UTILS.setElementStyle(widgetContentElem, formattedStyles.widgetContent);
    KAMPYLE_UTILS.setElementStyle(widgetContentElem, {fontFamily: 'Open Sans'}, true);
    var h2Elem = document.createElement('h2');
    h2Elem.className = "scTitle";
    h2Elem.style.fontSize = '16px';
    var headerForWidget = formData.screenCaptureSettings && formData.screenCaptureSettings.titleInstructionsScreenCapture ? formData.screenCaptureSettings.titleInstructionsScreenCapture : KAMPYLE_CONSTANT.TEXTS.SCREEN_CAPTURE.DEFAULT_TITLE;
    var h2Text = document.createTextNode(headerForWidget);
    h2Elem.appendChild(h2Text);
    var pElem = document.createElement('p');
    pElem.className = 'scParagraph';
    KAMPYLE_UTILS.setElementStyle(pElem, {
      fontSize: '12px',
      marginTop: '10px'
    });
    var descriptionForWidget = getScreenCaptureDescription(formData);
    var pText = document.createTextNode(descriptionForWidget);
    pElem.appendChild(pText);
    widgetContentElem.appendChild(h2Elem);
    widgetContentElem.appendChild(pElem);
    divWrapper.appendChild(widgetContentElem);
    divWrapper.appendChild(divFooter);
    bodyElem.appendChild(divWrapper);
    return bodyElem;
  }

  function createScreenCaptureHtml(headElem, bodyElem) {
    var htmlElem = document.createElement('html');
    htmlElem.appendChild(headElem);
    htmlElem.appendChild(bodyElem);
    return htmlElem
  }

  function createScreenCaptureInstructionWidget(formData, scContainer) {
    var formattedText = KAMPYLE_SCREEN_CAPTURE.overrideDefaultScreenCaptureTexts(formData.screenCaptureSettings) || {};
    var formattedStyles = KAMPYLE_SCREEN_CAPTURE.overrideDefaultScreenCaptureStyles(formData.screenCaptureSettings) || {};
    var headElem = createScreenCaptureHeader();
    var footerElem = createScreenCaptureFooter(formattedText, formattedStyles);
    var bodyElem = createScreenCaptureBody(formData, footerElem, formattedStyles);
    var htmlElem = createScreenCaptureHtml(headElem, bodyElem);
    createScreenCaptureIframe(htmlElem, scContainer);
  }

  export default {
    //Testing
    initScreenCaptureWidget: initScreenCaptureWidget,
    handleCaptureCancellation: handleCaptureCancellation,
    closeScreenCaptureWidget: closeScreenCaptureWidget,
    beforeOpen: beforeOpen,
    UserSnapModel: UserSnapModel,
    shouldProcessScreenCaptureAsComponent:
    shouldProcessScreenCaptureAsComponent,
    overrideDefaultScreenCaptureTexts: overrideDefaultScreenCaptureTexts,
    overrideDefaultScreenCaptureStyles: overrideDefaultScreenCaptureStyles,
    formatScreenCaptureWidget: formatScreenCaptureWidget,
    getSelectedTool: getSelectedTool,
    handleScrollIfNeeded: handleScrollIfNeeded,
    setBodyOverflowType: setBodyOverflowType,
    cancelCaptureClicked: cancelCaptureClicked,
    afterSend: afterSend,
    //Public
    getUserSnapInstance: getUserSnapInstance,
    init: init,
    addEscKeyDownListenerToIframe: addEscKeyDownListenerToIframe,

    createScreenCaptureWidget: createScreenCaptureWidget,
    isScreenCaptureEnabled: isScreenCaptureEnabled,
    onCancelScreenCaptureClick: onCancelScreenCaptureClick,
    onSubmitScreenCaptureClick: onSubmitScreenCaptureClick,
    showScreenCaptureSpinner: showScreenCaptureSpinner,
    createScreenCaptureInstructionWidget: createScreenCaptureInstructionWidget,
    createScreenCaptureBody: createScreenCaptureBody
  };